import React from "react";
import Modal from "react-bootstrap/Modal";
import { Tab, Tabs } from "react-bootstrap";
// import Pagination from "react-js-pagination";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import choVayConst from "constants/choVayConst";
import configs from "constants/configs";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import configsRole from "utils/configsRole";
import { kiemTraQuyen, quyenBanDau } from "utils/quyenNguoiDung";
import { convertToNumber } from "utils/numberExtension";
import handleEscapeKey from "utils/handleEscapeKey";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import cauHinh from "utils/cauHinh";

class ChiTietKhachHang extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.show || false, // Trạng thái popup
      dataSearch: {
        customerId: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      listTinhTrangNo: [],
      isMoney88: false,
      quyenThongTinKhac: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thongtinkhac,
      ),
      quyenThanhPhanGiaDinh: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thanhphangiadinh,
      ),
      quyenGhiChu: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu,
      ),
      quyenThongTinKhacGiaDinh: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac,
      ),
    };
    this.toggleModal = this.props.onHide.bind(this);
    // Tạo instance của useEscapeKey và gán vào this.escListener
    this.escListener = handleEscapeKey(this.props.onHide);
  }
  componentDidMount() {
    // Thêm listener chỉ khi modal mở
    if (this.state.isModalOpen) this.escListener.addListener();
    //Các quyền tab con của nhóm "Thông tin khách vay": tắt thì ẩn cả tab lẫn nội dung
    //Quyền cấp 3: tắt thì chỉ ẩn đúng ô "Ghi chú" / "Thông tin khác"
    Promise.all([
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinkhac),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thanhphangiadinh),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu),
      kiemTraQuyen(
        configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac,
      ),
    ]).then(
      ([
        quyenThongTinKhac,
        quyenThanhPhanGiaDinh,
        quyenGhiChu,
        quyenThongTinKhacGiaDinh,
      ]) =>
        this.setState({
          quyenThongTinKhac,
          quyenThanhPhanGiaDinh,
          quyenGhiChu,
          quyenThongTinKhacGiaDinh,
        }),
    );
    let { data, getDetailCustomer, lichSuGiaoDich, show, dbName } = this.props;
    if (show) {
      let { dataSearch } = this.state;
      const payload = {
        customerId: data.CustomerID,
        dbName: dbName,
        pageIndex: dataSearch.pageIndex,
        pageSize: dataSearch.pageSize,
      };
      dataSearch.customerId = data.CustomerID;
      getDetailCustomer(payload);
      lichSuGiaoDich(payload);
      this.setState({ choVay: data, dataSearch });
    }
    //Code lấy tình trạng nợ
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      console.log(response, "aaaaaaaaaaaaaaaa11111");
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: item.Code,
          label: item.Name,
        }));
        this.setState({ listTinhTrangNo: dataComboTinhTrang });
      }
    });
    //Chỉ công ty bật cấu hình isMoney88 mới hiển thị Nguồn khách/Nghề nghiệp/Khu vực/Hình thức vay
    ConfigSystemApi.GetConfigSystemByKeyConfig({
      key: cauHinh.sKey.IsMoney88,
    }).then((response) => {
      const value = response.data;
      this.setState({
        isMoney88:
          value === true ||
          value === 1 ||
          value === "1" ||
          value === "True" ||
          value === "true",
      });
    });
  }

  componentWillUnmount() {
    // Gỡ listener khi component unmount
    this.escListener.removeListener();
  }

  toggleModal() {
    // Cập nhật trạng thái popup và thêm/xóa listener khi cần
    this.setState(
      (prevState) => ({ isModalOpen: !prevState.isModalOpen }),
      () => {
        if (this.state.isModalOpen) {
          this.escListener.addListener();
        } else {
          this.escListener.removeListener();
        }
      },
    );
  }

  onHide = () => {
    this.setState({ isModalOpen: false });
    this.props.onHide();
  };

  handlePageChange = (pageNumber) => {
    let { lichSuGiaoDich, dbName } = this.props;
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    const payload = {
      ...dataSearch,
      dbName: dbName,
    };
    lichSuGiaoDich(payload);
  };
  showModalHopDong = (item) => () => {
    let { showChiTietHopDong } = this.props;
    if (showChiTietHopDong) showChiTietHopDong(item)();
  };
  render() {
    let props = this.props;
    let {
      quyenThongTinKhac,
      quyenThanhPhanGiaDinh,
      quyenGhiChu,
      quyenThongTinKhacGiaDinh,
    } = this.state;
    // let { dataSearch } = this.state;
    let { customer, show } = props;
    let { customerDetail, objLichSuGiaoDich, customerLoading } = customer;
    let {
      DinhDanh,
      CMT,
      AddressCMT,
      Phone,
      HKTT,
      Address,
      Birthday,
      DateCMT,
      UserName,
      TenNguonKh,
      DebtLevel,
      IsCus,
      Profession,
      WorkAddress,
      Income,
      PersonContact,
      PhoneContact,
      Note,
      PhoneFather,
      PhoneMother,
      PhoneWife,
      ProfessionFather,
      ProfessionMother,
      ProfessionWife,
      NameFather,
      NameMother,
      NameWife,
      NoteFamily,
      Img,
      TenNgheNghiep,
      TenKhuVuc,
      TenHinhThucVay,
    } = customerDetail;
    let { isMoney88 } = this.state;
    let { TongGiaoDich, TongTienChoVay, List } = objLichSuGiaoDich;
    let image = Img;
    if (typeof Img === "undefined" || Img === "") {
      image = "/app-assets/images/icon-avatar-default.png";
    } else {
      if (image && image.indexOf("http") > -1) {
      } else {
        image = configs.apiViewUpload + image;
      }
    }
    return (
      <Modal
        show={show}
        onHide={this.onHide}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={
          "modal-new modal fade text-left" +
          (props.className ? " " + props.className : "")
        }
        backdropClassName={props.backdropClassName}
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              {/* <i className="mdi mdi-file-document"></i> */}
              <img src="/app-assets/images/icon-thong-tin-ca-nhan.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              Thông tin cá nhân{" "}
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body style={{ marginTop: "-30px" }}>
          <div
            className={
              "loader loader-default " + (customerLoading ? "is-active" : "")
            }
          ></div>
          <div className="form-thongtin-kh-new">
            <div id="accordionWrap6" role="tablist" aria-multiselectable="true">
              <div className="card collapse-icon accordion-icon-rotate">
                <div id="heading61" className="card-header "></div>
                <div
                  id="accordion61"
                  aria-labelledby="heading61"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="thongtin-kh-new">
                        <div className="row">
                          <div className="col-md-2 no-image">
                            <div className="main-slider" id="main-slider1">
                              <a
                                href={
                                  image && image.indexOf("http") > -1
                                    ? image
                                    : image.indexOf("/Upload/TaiSanImage/") > -1
                                      ? configs.imageServer + image
                                      : configs.apiViewUpload + image
                                }
                                data-fancybox="images"
                              >
                                <img
                                  src={
                                    image && image.indexOf("http") > -1
                                      ? image
                                      : image.indexOf("/Upload/TaiSanImage/") >
                                          -1
                                        ? configs.imageServer + image
                                        : configs.apiViewUpload + image
                                  }
                                  width={180}
                                />
                              </a>
                            </div>
                          </div>
                          <div className="col-md-10">
                            <div className="from-thongtin1 form-mobile-chitietkh">
                              <div className="table-responsive table-new1">
                                <table className="table table-bordered">
                                  <tbody>
                                    <tr>
                                      <td className="text-left w-50 width-40">
                                        <span className="color-xanh-bold">
                                          {DinhDanh
                                            ? DinhDanh
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left" colSpan={2}>
                                        {/* Ngày sinh: {getDate(Birthday)} */}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left width-40">
                                        <img src="/app-assets/images/icon-birthday-v2.png" />
                                        <span className="color7">
                                          &nbsp;
                                          {getDate(Birthday)
                                            ? getDate(Birthday)
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left width-10 color-tim-bold ">
                                        Số CCCD :
                                      </td>
                                      <td className="text-left width-70">
                                        {CMT ? CMT : "Không có thông tin"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left width-40">
                                        <img src="/app-assets/images/icon-so-dien-thoai-v2.png" />
                                        <span className="color7">
                                          &nbsp;
                                          {getDate(Phone)
                                            ? getDate(Phone)
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left width-10 color-tim-bold ">
                                        Ngày Cấp :
                                      </td>
                                      <td className="text-left width-70">
                                        {getDate(DateCMT)
                                          ? getDate(DateCMT)
                                          : "Không có thông tin"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left width-40">
                                        <img src="/app-assets/images/icon-dia-chi-v2.png" />
                                        <span className="color7">
                                          &nbsp;
                                          {getDate(Address)
                                            ? getDate(Address)
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left width-10 color-tim-bold ">
                                        Nợi cấp :
                                      </td>
                                      <td className="text-left width-70">
                                        {AddressCMT
                                          ? AddressCMT
                                          : "Không có thông tin"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left width-40">
                                        <img src="/app-assets/images/icon-nguoi-theo-doi.png" />
                                        <span className="color7">
                                          &nbsp;
                                          {getDate(UserName)
                                            ? getDate(UserName)
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left width-10 color-tim-bold ">
                                        Hộ khẩu thường trú
                                      </td>
                                      <td className="text-left width-70">
                                        {HKTT ? HKTT : "Không có thông tin"}
                                      </td>
                                    </tr>
                                    {isMoney88 && (
                                      <>
                                        <tr>
                                          <td className="text-left width-40">
                                            <span className="color7-bold">
                                              Nguồn khách hàng :
                                            </span>
                                            <span className="color7">
                                              &nbsp;
                                              {TenNguonKh
                                                ? TenNguonKh
                                                : "Không có thông tin"}
                                            </span>
                                          </td>
                                          <td className="text-left width-10 color7-bold">
                                            Nghề nghiệp :
                                          </td>
                                          <td className="text-left width-70">
                                            {TenNgheNghiep
                                              ? TenNgheNghiep
                                              : "Không có thông tin"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-left width-40">
                                            <span className="color7-bold">
                                              Khu vực :
                                            </span>
                                            <span className="color7">
                                              &nbsp;
                                              {TenKhuVuc
                                                ? TenKhuVuc
                                                : "Không có thông tin"}
                                            </span>
                                          </td>
                                          <td className="text-left width-10 color7-bold">
                                            Hình thức vay :
                                          </td>
                                          <td className="text-left width-70">
                                            {TenHinhThucVay
                                              ? TenHinhThucVay
                                              : "Không có thông tin"}
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-detail-hd">
            <Tabs className="tab-detail-mm">
              <Tab
                eventKey="lichsugiaodich"
                title={
                  <h4 className="nav-link tab-v2">
                    <div className="badge badge-pill-v3 bg-blue-morman">
                      {TongGiaoDich}
                    </div>{" "}
                    Lịch sử giao dịch
                  </h4>
                }
              >
                <div className="Table-main-morman table-noboder-new margin-top-20px">
                  <div className="table-responsive table-new1">
                    <table className="table table-bordered table-hover table-rounded">
                      <thead>
                        <tr>
                          <th className="w-5">
                            <span className="color-do-bold">
                              [{TongGiaoDich}]
                            </span>{" "}
                            <br />
                            &nbsp;
                          </th>
                          <th className="w-15">
                            Mã cho vay <br />
                            &nbsp;
                          </th>
                          <th className="w-15">
                            Ngày vay <br />
                            &nbsp;
                          </th>
                          <th className="text-right">
                            Số tiền vay
                            <br />{" "}
                            <i className="la la-dollar color-do-bold"></i>
                            <span className="color-do-bold">
                              = {formatNumber(TongTienChoVay)}
                            </span>
                          </th>
                          <th className="">
                            Trạng thái
                            <br />
                            &nbsp;
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {List.map((item, index) => (
                          <tr key={"lichSuGiaoDic" + item.ChoVayId}>
                            <td>{index + 1}</td>
                            <td>
                              <p onClick={this.showModalHopDong(item)}>
                                <span className="color-xanh-bold">
                                  {item.Code}
                                </span>
                              </p>
                            </td>
                            <td>{getDate(item.NgayVay)}</td>
                            <td className="text-right">
                              {formatNumber(item.SoTienVayConLai)}
                            </td>
                            <td>
                              <span
                                className={`mat-chip status-${item.Status}`}
                              >
                                {choVayConst.StatusText[item.Status]}{" "}
                              </span>{" "}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="footer-page-new">
                  <div className="col-xl-12 col-lg-12">
                    {/* <div className="paniation-new d-flex just-end">
                      <nav aria-label="Page navigation">
                        <Pagination
                          activePage={dataSearch.pageIndex}
                          itemsCountPerPage={dataSearch.pageSize}
                          totalItemsCount={parseInt(TongGiaoDich)}
                          pageRangeDisplayed={5}
                          onChange={this.handlePageChange}
                          itemClass="page-item"
                          linkClass="page-link"
                          activeClass="active"
                        />
                      </nav>
                    </div> */}
                  </div>
                </div>
              </Tab>
              {quyenThongTinKhac && (
                <Tab
                  eventKey="thongtinkhac"
                  title={
                    <h4 className="nav-link tab-v2">
                      {" "}
                      <i className="mdi mdi-information"></i> Thông tin khác
                    </h4>
                  }
                >
                  <div className="table-from-detailaccout">
                    <div className="select-thongtinvay">
                      <div className="row">
                        <div className="col-md-3 col-lg-3">
                          <div className="from-thongtinvay">
                            <div className="row">
                              <div className="col-6">
                                <p>Nguồn khách hàng:&nbsp;</p>
                              </div>
                              <div className="col-6 text-left text-normal">
                                <p> {TenNguonKh}</p>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <p>Tình trạng:&nbsp;</p>
                              </div>
                              <div className="col-6 text-left text-normal">
                                {this.state.listTinhTrangNo.length > 0 &&
                                  this.state.listTinhTrangNo.map(
                                    (item, index) => (
                                      <>
                                        {convertToNumber(DebtLevel) ===
                                          convertToNumber(item.value) && (
                                          <span
                                            className={`${choVayConst.DebtLevelColor[DebtLevel]}`}
                                          >
                                            {item.label}
                                          </span>
                                        )}
                                      </>
                                    ),
                                  )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-6">
                                <p> Loại đối tác:&nbsp;</p>
                              </div>
                              <div className="col-6 text-left text-normal color-xanh">
                                {IsCus ? "Khách hàng" : "Chủ nợ"}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <p> Nghề nghiệp:&nbsp;</p>
                              </div>
                              <div className="col-6 text-left text-normal color7">
                                {Profession}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <p> Nơi làm việc:&nbsp;</p>
                              </div>
                              <div className="col-6 text-left text-normal color7">
                                {WorkAddress}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                          <div className="from-thongtinvay">
                            <div className="row">
                              <div className="col-6">
                                <p> Thu nhập:&nbsp;</p>
                              </div>
                              <div className="col-6 text-left text-normal color7">
                                {formatNumber(Income)}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-6">
                                <p> Người liên hệ:&nbsp;</p>
                              </div>
                              <div className="col-6 text-left text-normal color7">
                                {PersonContact}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-6">
                                <p> Số điện thoại người liên hệ:&nbsp;</p>
                              </div>
                              <div className="col-6 text-left text-normal color7">
                                {PhoneContact}
                              </div>
                            </div>

                            {quyenGhiChu && (
                              <div className="row">
                                <div className="col-6">
                                  <p> Ghi chú:&nbsp;</p>
                                </div>
                                <div className="col-6 text-left text-normal">
                                  <textarea
                                    className="col-md-12 col-lg-12 textarea-view color7"
                                    value={Note}
                                    readOnly
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              )}
              {quyenThanhPhanGiaDinh && (
                <Tab
                  eventKey="thanhphangiadinh"
                  title={
                    <h4 className="nav-link tab-v2">
                      <i className="mdi mdi-account-multiple"></i> Thành phần
                      gia đình
                    </h4>
                  }
                >
                  <div className="table-from-detailaccout1">
                    <div className="select-thongtinvay">
                      <div className="row">
                        <div className="col-md-3 col-lg-3">
                          <div className="from-thongtinvay">
                            <div className="row" style={{ borderLeft: "none" }}>
                              <div className="col-7 img-icon-v2 ">
                                <img src="/app-assets/images/icon-vo-chong.png" />
                                &nbsp;<span>Họ tên chồng/vợ:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left text-normal color7">
                                {NameWife}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-7 img-icon-v2">
                                <img src="/app-assets/images/icon-so-dien-thoai-v2.png" />
                                &nbsp;<span>Số điện thoại chồng/vợ:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left  text-normal color7">
                                {PhoneWife}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-7 img-icon-v2">
                                <img src="/app-assets/images/icon-nghe-nghiep-me.png" />
                                &nbsp;<span>Nghề nghiệp chồng/vợ:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left text-normal color7">
                                {ProfessionWife}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3 col-lg-3 color7">
                          <div className="from-thongtinvay">
                            <div className="row">
                              <div className="col-7  img-icon-v2">
                                <img src="/app-assets/images/icon-ten-bo.png" />
                                &nbsp;<span>Họ tên bố:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left text-normal color7">
                                {NameFather}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-7 img-icon-v2">
                                <img src="/app-assets/images/icon-so-dien-thoai-v2.png" />
                                &nbsp;<span>Số điện thoại bố:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left text-normal color7">
                                {PhoneFather}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-7 img-icon-v2">
                                <img src="/app-assets/images/icon-nghe-nghiep-me.png" />
                                &nbsp;<span>Nghề nghiệp chồng/vợ:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left text-normal color7">
                                {ProfessionFather}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                          <div className="from-thongtinvay">
                            <div className="row">
                              <div className="col-7 img-icon-v2">
                                <img src="/app-assets/images/icon-ten-me.png" />
                                &nbsp;<span>Họ tên bố:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left text-normal color7">
                                {NameMother}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-7 img-icon-v2">
                                <img src="/app-assets/images/icon-so-dien-thoai-v2.png" />
                                &nbsp;<span>Số điện thoại mẹ:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left text-normal color7">
                                {PhoneMother}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-7 img-icon-v2">
                                <img src="/app-assets/images/icon-nghe-nghiep-me.png" />
                                &nbsp;<span>Nghề nghiệp mẹ:&nbsp;</span>
                              </div>
                              <div className="col-5 text-left text-normal color7">
                                {ProfessionMother}
                              </div>
                            </div>
                          </div>
                        </div>
                        {quyenThongTinKhacGiaDinh && (
                          <div className="col-md-3 col-lg-3">
                            <div className="row">
                              <div className="col-12 img-icon-v2 color7-bold">
                                <img src="/app-assets/images/icon-ghi-chu-v2.png" />
                                &nbsp;<span>Ghi chú:&nbsp;</span>
                              </div>
                              <div className="col-12 text-left text-normal">
                                <textarea
                                  className="col-md-12 col-lg-12 textarea-view color7"
                                  value={NoteFamily}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {/* <div className="col-md-12 col-lg-12">
                        <div className="from-notevay">
                          <p>Ghi chú: {NoteFamily}</p>
                        </div>
                      </div> */}
                      </div>
                    </div>
                  </div>
                </Tab>
              )}
            </Tabs>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-right">
            <button
              type="button"
              className="btn btn-new-main btn-closenew"
              onClick={props.onHide}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-close"></i>
              </span>
              Đóng
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ChiTietKhachHang;
